module.exports = __webpack_public_path__ + "img/20220425_174906.a0610b33.jpg";